"use client";
import React from "react";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";

export default function BottomBanner() {
  const router = useRouter();
  const { user, token, isAuthenticated } = useSelector(state => state.auth);

  const handleSignUp = () => {
    // Check if user is authenticated
    if (!isAuthenticated && !token && !user) {
      router.push('/login');
      return;
    }

    // Check user type and redirect accordingly
    const userType = user?.user_type;
    if (userType === "Customer" || userType === "customer") {
      router.push('/customer-dashboard/job-post');
    } else if (userType === "Freelancer" || userType === "freelancer") {
      router.push('/freelancer-dashboard/jobs');
    } else {
      // Default to login if user type is unclear
      router.push('/login');
    }
  };
  return (
    <div className="w-full flex justify-center">
      <div className="w-full max-w-[1620px] mx-2 sm:mx-4 md:mx-8 my-4 md:my-8 relative overflow-hidden rounded-[16px] md:rounded-[32px] flex flex-col items-center py-8 md:py-12 lg:py-[72px] px-4 md:px-6 lg:px-12"
        style={{ background: 'linear-gradient(to bottom right, #3A599C, #335191, #294685)' }}>
        {/* Grid Lines */}
        <div className="absolute inset-0 opacity-40">
          {/* Vertical lines */}
          <div className="absolute inset-0" style={{
            backgroundImage: 'linear-gradient(90deg, rgba(255,255,255,0.3) 1px, transparent 1px)',
            backgroundSize: '80px 100%'
          }}></div>
          {/* Horizontal lines */}
          <div className="absolute inset-0" style={{
            backgroundImage: 'linear-gradient(0deg, rgba(255,255,255,0.3) 1px, transparent 1px)',
            backgroundSize: '100% 80px'
          }}></div>
        </div>
        <div className="relative z-10 flex flex-col items-center gap-8 md:gap-12 text-center text-white">
          <div className="flex flex-col items-center gap-4 md:gap-6 max-w-full md:max-w-[1034px] px-2">
            <div className="text-xl sm:text-2xl md:text-3xl lg:text-[36px] leading-tight lg:leading-[36px] font-medium">
              Start Building Your Success Story Today
            </div>
            <div className="text-xs sm:text-sm md:text-base leading-6 font-semibold">
              Create your profile, explore projects, and start your journey to success today!
            </div>
          </div>
          <button 
            onClick={handleSignUp}
            className="h-[42px] md:h-[49px] rounded-3xl border-white border-solid border-[1px] flex items-center justify-center py-3 md:py-4 px-6 md:px-8 hover:bg-white/10 transition-colors cursor-pointer"
          >
            <div className="text-sm md:text-base leading-6 font-semibold">Start today</div>
          </button>
        </div>
      </div>
    </div>
  );
}

